import React, { useState } from 'react';

const HelpPage = () => {
    const [openIndex, setOpenIndex] = useState(null);

    const toggleAccordion = (index) => {
        setOpenIndex(openIndex === index ? null : index);
    };

    /**
     * 화면에 있는 것만 적는다.
     *
     * 여기 있던 설명은 구조가 바뀌기 전 것이었다 -- 구역에 점검표를 붙이라거나,
     * 시설 상세의 QR 을 붙여 두라거나. 그 QR 은 어느 화면에도 없다. 없는 기능을
     * 설명하는 도움말은 못 찾는 사람을 더 오래 헤매게 한다.
     */
    const faqData = [
        {
            category: '시작하기',
            question: '건물과 구역은 어떻게 등록하나요?',
            answer: '[시설]에서 우측 상단 [시설 등록]으로 건물을 만듭니다. 만든 뒤 그 건물의 상세 화면에서 [구역 관리]로 들어가면 층·시설별 구역(예: 3층 화장실, 지하 주차장)을 더할 수 있습니다. 구역은 점검할 장소를 나누는 단위일 뿐이고, 무엇을 언제 점검할지는 점검 계획에서 정합니다.'
        },
        {
            category: '시작하기',
            question: '함께 일할 사람은 어떻게 추가하나요?',
            answer: '[사용자]에서 [사용자 초대]를 누르고 이름·이메일·역할을 적으면 초대 링크가 만들어집니다. 그 자리에서 메시지를 복사해 카톡이나 문자로 보내 주세요. 받은 분이 링크를 열어 비밀번호를 직접 정하면 계정이 만들어집니다. 링크는 7일 뒤 만료되고, 놓쳤으면 [가입 대기] 목록에서 [링크]를 눌러 다시 만들 수 있습니다.'
        },
        {
            category: '시작하기',
            question: '비밀번호를 잊었습니다.',
            answer: '로그인 화면에서 이메일을 적고 [관리자에게 재설정 요청]을 누르세요. 관리자 폰으로 알림이 가고 대시보드의 [우선 조치 사항]에도 뜹니다. 관리자는 [사용자] 목록에서 그 사람의 [비밀번호 재설정]을 눌러 링크를 만들고, 메시지를 복사해 보내 주면 됩니다. 받은 분이 링크를 열어 새 비밀번호를 정하면 바로 로그인됩니다. 링크는 24시간 뒤 만료되고, 한 번 쓰면 다시 쓸 수 없습니다. 비밀번호를 바꾸면 다른 기기에서 로그인해 둔 것은 모두 끊깁니다. 지금 쓰는 비밀번호를 알고 있다면 [설정]에서 직접 바꾸는 편이 빠릅니다.'
        },
        {
            category: '점검 준비',
            question: '점검표는 어떻게 만들어 쓰나요?',
            answer: '[점검 설정] > [점검표]에서 확인할 항목을 모아 점검표를 만듭니다. 점검표는 구역에 붙이지 않습니다. [점검 설정] > [점검 계획]에서 순회 경로의 들를 곳마다 어느 점검표를 쓸지 고릅니다. 같은 장소를 경비 순찰과 정기순회가 서로 다른 점검표로 돌 수 있는 것이 이 때문입니다.'
        },
        {
            category: '점검 준비',
            question: '점검 계획은 무엇을 정하는 건가요?',
            answer: '언제 몇 번 도는지(시간대와 횟수), 한 번에 어디를 도는지(순회 경로의 들를 곳), 누가 맡는지를 정합니다. 경로 안의 들를 곳은 한 회차에 전부 돕니다 — 다섯 곳 중 세 곳만 하면 그 회차는 3/5로 남습니다. 시간대마다 이름을 붙이면(「1회차」, 「점심 전」) 화면에서 그 이름으로 불립니다.'
        },
        {
            category: '현장 점검',
            question: '작업자는 오늘 무엇을 해야 하는지 어떻게 아나요?',
            answer: '[오늘 할 점검]에 아직 하지 않은 것만 나옵니다. 자기에게 맡겨진 계획과, 아무에게도 맡겨지지 않은 계획이 보입니다. [점검]을 누르면 첫 곳부터 시작하고, 한 곳을 제출할 때마다 다음 곳으로 이어서 갈지 물어봅니다.'
        },
        {
            category: '현장 점검',
            question: '어제 못 한 점검을 오늘 할 수 있나요?',
            answer: '같은 주 안에서는 됩니다. [오늘 할 점검] 아래 「이번 주에 못 한 점검」에서 바로 시작할 수 있습니다. 다만 그 회차는 미이행 그대로 남습니다 — 월요일 오전 순찰을 토요일에 했다면 월요일 오전에 돈 것이 아니기 때문입니다. 다녀온 곳은 표시되므로 한 일이 사라지지는 않습니다.'
        },
        {
            category: '이슈 관리',
            question: '점검 중 발견한 문제는 어떻게 올리나요?',
            answer: '[이슈]에서 [이슈 등록]으로 사진과 함께 올립니다. 관리자가 확인해 [처리중] · [해결 완료]로 상태를 바꾸고, 해결 사진과 조치 내용을 함께 남길 수 있습니다. 대시보드의 「우선 조치 사항」에 미해결 건수가 뜹니다.'
        },
        {
            category: '현황 보기',
            question: '이번 주에 무엇이 밀렸는지 어떻게 보나요?',
            answer: '[주간 점검 현황]이 계획별로 한 줄, 요일별로 한 칸입니다. 칸을 누르면 그 날 회차가 어디를 들렀고 어디를 빠뜨렸는지 나옵니다. [기록 모두 보기]로 그 회차의 점검 기록을 한 화면에서 이어서 볼 수 있습니다.'
        },
        {
            category: '현황 보기',
            question: '실수로 지운 점검 기록을 되살릴 수 있나요?',
            answer: '됩니다. 지운 기록은 사라지지 않습니다. 시설 상세의 「점검 내역」 옆 [지운 기록]에서 누가 언제 지웠는지와 함께 볼 수 있고, [되살리기] 한 번으로 원래 자리로 돌아갑니다. 소유자·최고 관리자, 그리고 「점검 기록 삭제·복구」 권한을 받은 사람이 쓸 수 있습니다.'
        }
    ];

    return (
        <div className="help-page bg-light min-vh-100 pb-5">
            <style>{`
                .help-header {
                    background: linear-gradient(135deg, var(--primary-color) 0%, #3a32a8 100%);
                    color: white;
                    padding: 3rem 1.5rem;
                    border-radius: 0 0 24px 24px;
                    margin-bottom: 2rem;
                }
                .faq-card {
                    background: white;
                    border-radius: 16px;
                    border: 1px solid #eee;
                    margin-bottom: 1rem;
                    box-shadow: 0 2px 8px rgba(0,0,0,0.02);
                    overflow: hidden;
                    transition: all 0.2s;
                }
                .faq-header {
                    padding: 1.25rem 1.5rem;
                    cursor: pointer;
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    background: white;
                    word-break: keep-all;
                }
                .faq-header:hover {
                    background: #fcfcfc;
                }
                .faq-body {
                    padding: 0 1.5rem 1.25rem 1.5rem;
                    background: #f8f9fa;
                    color: #555;
                    font-size: 0.95rem;
                    line-height: 1.6;
                    border-top: 1px solid #f1f3f5;
                    word-break: keep-all;
                }
                .faq-category {
                    font-size: 0.75rem;
                    font-weight: 700;
                    color: var(--primary-color);
                    background: var(--primary-color-10, rgba(79, 70, 229, 0.1));
                    padding: 0.2rem 0.6rem;
                    border-radius: 8px;
                    margin-bottom: 0.5rem;
                    display: inline-block;
                }
                .contact-card {
                    background: white;
                    border-radius: 20px;
                    padding: 2rem;
                    text-align: center;
                    margin-top: 3rem;
                    border: 1px solid #eee;
                    box-shadow: 0 4px 15px rgba(0,0,0,0.03);
                }
                .contact-icon {
                    width: 60px;
                    height: 60px;
                    background: #f1f5f9;
                    border-radius: 50%;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    font-size: 1.5rem;
                    color: var(--primary-color);
                    margin: 0 auto 1rem auto;
                }
            `}</style>

            <div className="help-header text-center">
                <h3 className="fw-bold mb-2">무엇을 도와드릴까요?</h3>
                <p className="opacity-75 mb-0" style={{ wordBreak: 'keep-all' }}>자주 묻는 질문(FAQ)과 서비스 이용 가이드를 확인해보세요.</p>
            </div>

            <div className="container" style={{ maxWidth: '800px' }}>
                <h5 className="fw-bold mb-4 px-2">자주 묻는 질문 (FAQ)</h5>

                <div className="faq-list px-2">
                    {faqData.map((faq, index) => (
                        <div key={index} className="faq-card">
                            <div className="faq-header" onClick={() => toggleAccordion(index)}>
                                <div className="pe-3">
                                    <div className="faq-category">{faq.category}</div>
                                    <div className="fw-bold text-dark" style={{ fontSize: '1.05rem' }}>
                                        <span className="text-primary me-2 fw-bold">Q.</span>
                                        {faq.question}
                                    </div>
                                </div>
                                <div className="text-muted">
                                    <i className={`bi bi-chevron-${openIndex === index ? 'up' : 'down'}`}></i>
                                </div>
                            </div>

                            {openIndex === index && (
                                <div className="faq-body animate__animated animate__fadeIn animate__faster pt-3">
                                    <span className="text-secondary fw-bold pe-2" style={{ fontSize: '1.1rem' }}>A.</span>
                                    {faq.answer}
                                </div>
                            )}
                        </div>
                    ))}
                </div>

                <div className="contact-card mx-2">
                    <div className="contact-icon">
                        <i className="bi bi-headset"></i>
                    </div>
                    <h5 className="fw-bold mb-2" style={{ wordBreak: 'keep-all' }}>원하시는 답변을 찾지 못하셨나요?</h5>
                    <p className="text-muted mb-4 small" style={{ wordBreak: 'keep-all' }}>
                        도움말에서 해결되지 않은 문제가 있다면 아래 고객센터 이메일로 문의해주세요. <br className="d-none d-md-block" />
                        확인 후 빠르게 답변드리겠습니다.
                    </p>
                    <a href="mailto:cs@sunheung.com" className="btn btn-primary px-3 py-2 rounded-pill fw-bold shadow-sm d-inline-flex flex-column flex-sm-row align-items-center justify-content-center" style={{ gap: '0.25rem', wordBreak: 'keep-all' }}>
                        <div className="text-nowrap"><i className="bi bi-envelope-fill me-2"></i>cs@sunheung.com</div>
                        <div className="text-nowrap">문의하기</div>
                    </a>
                </div>
            </div>
        </div>
    );
};

export default HelpPage;
